import { FormElement, FormId } from "../../../../../components/enums";
import {
  FormSchema,
  ComplexFormSchemaComponents,
  SimpleFormSchemaComponents,
} from "../../../../../components/types";
import { from1to10 } from "../../../../../shared";
import { selectCountry } from "../../../../../store/HOC/genericUI.selectors";
import { postalCodeMask } from "../../../../../utilities/masks";
import {
  selectAreInjuredPersons,
  selectCircumAvailableCities,
  selectGotInjuredPersonsDetails,
  selectIncidentOtherPersonsData,
  selectIncidentOtherPersonsParticipantsData,
  selectUIData,
} from "../incident.selectors";
import {
  setAreInjuredPersons,
  setAvailableCities,
  setGotInjuredPersonsDetails,
  setUIObjectField,
} from "../incident.slice";

import { ComponentId } from "./enums";

const multiplePersonForm = (
  id: string
): FormSchema<SimpleFormSchemaComponents> => ({
  id,
  formId: FormId.INCIDENT_OTHER_PERSONS,
  selector: selectIncidentOtherPersonsParticipantsData,
  content: [
    {
      title: "Dane osoby",
      sections: [
        {
          id: ["persons-section-data-1", id].join("-"),
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: `persons[${id}][name]`,
              label: "Imię",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: `persons[${id}][surname]`,
              label: "Nazwisko",
              required: true,
            },
          ],
        },
        {
          id: ["persons-section-data-2", id].join("-"),
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.PHONE,
              country: selectCountry(selectUIData)(
                `otherPersonspersons${id}phone`
              ),
              id: `persons[${id}][phone]`,
              onChange: setUIObjectField,
              label: "Telefon",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: `persons[${id}][email]`,
              label: "Email",
            },
          ],
        },
      ],
    },
    {
      title: "Miejsce zamieszkania",
      sections: [
        {
          id: ["persons-section-address-data-1", id].join("-"),
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: `persons[${id}][street]`,
              label: "Ulica",
            },
            {
              type: FormElement.INPUT,
              id: `persons[${id}][street2]`,
              label: "Numer budynku / mieszkania",
            },
          ],
        },
        {
          id: ["persons-section-address-data-2", id].join("-"),
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.ZIP_CODE,
              mask: postalCodeMask,
              id: `persons[${id}][zipCode]`,
              label: "Kod pocztowy",
              // LPPLWEBMOB-728
              onChange: setAvailableCities,
            },
            {
              type: FormElement.SELECT_CITY,
              id: `persons[${id}][city]`,
              label: "Miejscowość",
              items: [],
              selectAvailableCities: selectCircumAvailableCities,
            },
          ],
        },
      ],
    },
  ],
});

export const form: FormSchema<
  ComplexFormSchemaComponents | SimpleFormSchemaComponents
> = {
  formId: FormId.INCIDENT_OTHER_PERSONS,
  selector: selectIncidentOtherPersonsData,
  content: [
    {
      title: "Inni uczestnicy zdarzenia",
      sections: [
        {
          id: "incident-other-persons-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.SELECT,
              id: ComponentId.NUMBER_OF_PARTICIPANTS,
              items: [...from1to10],
              required: true,
              label:
                "Ile osób ogółem w chwili zdarzenia było w Pana/Pani pojeździe i innych pojazdach?",
            },
          ],
        },
        {
          id: "incident-other-persons-data-2",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.ARE_INJURED_PERSONS,
              required: true,
              label: "Czy wśród tych osób były osoby poszkodowane w zdarzeniu?",
              onChange: setAreInjuredPersons,
              items: [
                {
                  label: "tak",
                  value: "true",
                },
                {
                  label: "nie",
                  value: "false",
                },
              ],
            },
          ],
        },
        {
          id: "incident-other-persons-data-3",
          isVisible: selectAreInjuredPersons,
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.GOT_INJURED_PERSONS_DETAILS,
              required: true,
              label: "Czy posiadasz dane osób poszkodowanych w zdarzeniu?",
              onChange: setGotInjuredPersonsDetails,
              items: [
                {
                  label: "tak",
                  value: "true",
                },
                {
                  label: "nie",
                  value: "false",
                },
              ],
            },
          ],
        },
        {
          id: "incident-other-persons-data-4",
          isVisible: selectGotInjuredPersonsDetails,
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.MULTIPLE_PERSON,
              id: ComponentId.PERSONS,
              form: multiplePersonForm,
            },
          ],
        },
      ],
    },
  ],
};
